import { useCallback, useState } from 'react'
import uniq from 'lodash/uniq'

export function useEmptyGroups() {
  const [emptyGroups, setEmptyGroups] = useState<string[]>([])

  const addEmptyGroup = useCallback((newEmptyGroup) => {
    setEmptyGroups((currentEmptyGroups) =>
      uniq([...currentEmptyGroups, newEmptyGroup])
    )
  }, [])

  const removeEmptyGroup = useCallback((emptyGroup) => {
    setEmptyGroups((currentEmptyGroups) =>
      currentEmptyGroups.filter((e) => e !== emptyGroup)
    )
  }, [])

  return [emptyGroups, addEmptyGroup, removeEmptyGroup] as const
}
